import * as React from "react";

function SvgIconMapPetStore(props) {
  return (
    <svg width={27.325} height={26.002} {...props}>
      <path
        data-name="Icon map-pet-store"
        d="M13.663 11.414a3.7 3.7 0 013.639 2.332c.522 1.68.452 3.522 2.749 4.479 2.039.579 2.81 1.307 2.81 3.258 0 1.557-1.6 3.213-3.654 3.419a9.726 9.726 0 01-5.544-.779 9.717 9.717 0 01-5.542.779c-2.058-.204-3.658-1.865-3.658-3.417 0-1.91.823-2.718 2.858-3.271 2.5-1.068 2.168-2.94 2.727-4.548a3.733 3.733 0 013.615-2.252zm11.473-1.16c-.621-.45-3.154 1.307-3.951 2.177a2.494 2.494 0 00-.786 1.8 2.637 2.637 0 002.7 2.561 2.708 2.708 0 002.508-1.6c.786-1.678.829-3.993-.471-4.935zm-22.947 0c-1.3.942-1.256 3.261-.474 4.947a2.707 2.707 0 002.507 1.6 2.636 2.636 0 002.7-2.561 2.493 2.493 0 00-.785-1.8c-.794-.876-3.327-2.634-3.948-2.183zm14.808-9.24c6.3.893 5.862 9.757.814 9.043a3.11 3.11 0 01-2.7-2.636c-.168-1.341-.548-6.746 1.886-6.407zm-6.669 0c2.435-.34 2.055 5.066 1.888 6.411a3.108 3.108 0 01-2.7 2.636c-5.053.715-5.492-8.147.813-9.047z"
        fill="none"
        stroke="#333"
        strokeWidth={2}
      />
    </svg>
  );
}

export default SvgIconMapPetStore;
